import { EventAvailable } from '@mui/icons-material';
import SegredoJustica from '@mui/icons-material/Lock';
import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/processo.css';
import Configuracao from '../../util/Configuracao';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import ReactComponent from '../ReactComponent';
import AbrirDialogComposicaoButton from '../shared/AbrirDialogComposicaoButton';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import RecarregarCacheServidorDeUmProcesso from './RecarregarCacheServidorDeUmProcesso';
import RemoverProcessoPauta from './RemoverProcessoPauta';

class FerramentasDetalhesProcessoPauta extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            handleClickNumeroProcesso: action,
            isProcessoEmPauta: computed,
            tooltipBotaoIncluirEmPauta: computed,
            corBotaoIncluirEmPauta: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    handleClickNumeroProcesso = () => {
        this.pautaJulgamentoStore.processoScroll = this.registro;
    };

    incluirEmPauta = async () => {
        let mensagens = await this.getAlertasInclusaoPautaSessao();
        if (mensagens.length > 0) {
            this.mensagemStore.abrirMensagemAlerta(
                <div>
                    {mensagens.map((mensagem) => (
                        <div key={this.nextKey}>{mensagem}</div>
                    ))}
                </div>
            );
        }

        await this.pautaJulgamentoStore.incluirProcessoPauta(this.registro);
        this.mensagemStore.abrirMensagemSucesso(
            `Processo (${this.registro.processo.numeroCompleto}) incluído na pauta com sucesso.`
        );
        if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            this.sessaoStore.recarregarListaProcessos();
        }
    };

    async getAlertasInclusaoPautaSessao() {
        return this.sessaoStore.getAlertasInclusaoPautaSessao(
            this.registro,
            this.registro.detalhes,
            this.pautaJulgamentoStore.pautaSelecionada.composicaoPadrao
        );
    }

    get isProcessoEmPauta() {
        return this.pautaJulgamentoStore.isProcessoEmPauta(this.registro);
    }

    render() {
        return (
            <Box
                id="divCabecalhoDetalhes"
                style={{ display: 'flex', justifyContent: 'space-between' }}
            >
                <Box
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        maxHeight: '75px',
                        flexWrap: 'wrap',
                        marginBottom: '8px'
                    }}
                >
                    <Box style={{ display: 'flex', flexWrap: 'nowrap', margin: '4px 0px' }}>
                        <Tooltip
                            placement="top"
                            title={<Typography>Selecionar o processo na lista.</Typography>}
                        >
                            <Box onClick={this.handleClickNumeroProcesso}>
                                <Typography
                                    component="h3"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        whiteSpace: 'nowrap',
                                        margin: '0px 0px 0px 6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Typography
                                        component="span"
                                        style={{
                                            fontSize: '17px',
                                            color: this.registro.segredoJustica ? red[900] : 'black',
                                            fontWeight: this.registro.segredoJustica ? 'bold' : ''
                                        }}
                                    >
                                        {this.processo.numeroCompleto}
                                    </Typography>
                                </Typography>
                            </Box>
                        </Tooltip>
                        <Box>
                            {this.registro.segredoJustica && (
                                <Tooltip
                                    title={'SEGREDO DE JUSTIÇA'}
                                    placement="top"
                                >
                                    <SegredoJustica
                                        style={{
                                            height: '24px',
                                            width: '24px',
                                            marginLeft: '4px',
                                            marginRight: '4px',
                                            color: red[900]
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </Box>

                    <div style={{ marginLeft: '4px', marginRight: '4px' }}>
                        <LabelNumeroProcesso
                            exibirIcone
                            habilitarCopiarNumero
                            registro={this.registro}
                        />
                    </div>
                    <div style={{ margin: '0px 4px' }}>
                        <IconesMagistradosProcesso
                            dense
                            registro={this.registro}
                        />
                    </div>
                    <div style={{ marginLeft: '8px' }}>
                        {this.isProcessoEmPauta && <AbrirDialogComposicaoButton registro={this.registro} />}
                    </div>
                </Box>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginRight: '10px',
                        justifyContent: 'flex-end',
                        flexWrap: 'wrap'
                    }}
                >
                    {this.isProcessoEmPauta && <RecarregarCacheServidorDeUmProcesso registro={this.registro} />}
                    {this.renderIncluirRemoverProcesso()}
                </div>
            </Box>
        );
    }

    renderIncluirRemoverProcesso() {
        return (
            <>
                {this.isProcessoEmPauta ? (
                    <RemoverProcessoPauta registro={this.registro} />
                ) : (
                    this.renderIncluirProcesso()
                )}
            </>
        );
    }

    get tooltipBotaoIncluirEmPauta() {
        if (this.pautaJulgamentoStore.isDataSessaoPresencialFutura()) {
            return 'Incluir em pauta';
        }

        return 'Não é possível incluir processos em pauta após início da sessão presencial.';
    }

    get corBotaoIncluirEmPauta() {
        if (this.pautaJulgamentoStore.isDataSessaoPresencialFutura()) {
            return 'black';
        }

        return 'inherited';
    }

    renderIncluirProcesso() {
        if (this.pautaJulgamentoStore.carregandoPartes) {
            return (
                <Tooltip title="Carregando partes dos processos">
                    <CircularProgress size="10" />
                </Tooltip>
            );
        }

        return (
            <Tooltip title={this.tooltipBotaoIncluirEmPauta}>
                <span>
                    <IconButton
                        disabled={!this.pautaJulgamentoStore.isDataSessaoPresencialFutura()}
                        onClick={this.incluirEmPauta}
                        style={{ padding: '8px' }}
                        size="large"
                    >
                        <EventAvailable style={{ color: this.corBotaoIncluirEmPauta }} />
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(FerramentasDetalhesProcessoPauta));
